import React from "react";
import Icon from "../../../components/AppIcon";

const NavigationTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: "apartments", label: "Apartments", icon: "Building" },
    { id: "rooms", label: "Rooms", icon: "Bed" },
  ];

  return (
    <div className="sticky top-16 z-40 bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/60 border-b border-border">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="flex justify-center py-4">
          <div className="flex bg-muted rounded-lg p-1">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                className={`
                  flex items-center space-x-2 px-6 py-3 rounded-md text-sm font-medium transition-smooth
                  ${
                    activeTab === tab.id
                      ? "bg-primary text-primary-foreground shadow-subtle"
                      : "text-muted-foreground hover:text-foreground hover:bg-background"
                  }
                `}
              >
                <Icon name={tab.icon} size={16} />
                <span>{tab.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavigationTabs;
